


import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'teleLada'})
export class TeleLadaPipe implements PipeTransform {
  transform(value: string): any {
    value = value.replace('-', '');
    if(value.length <= 3)
      return value;
    else{
      let lada = value.substr(0, 3);
      let telefono = value.substr(3, value.length);
      return  lada + '-' + telefono;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/form/core/directive/telefono.pipe.ts